<template>
  <a-card :bordered="false">
    <a-form-model
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      :label-col="currentFormLayout2.labelCol"
      :wrapper-col="currentFormLayout2.wrapperCol">
      <a-form-model-item label="标题" prop="title">
        <a-input
          v-model="ruleForm.title"
          placeholder="请输入"
          :maxLength="30"
          style="max-width:400px;"/>
      </a-form-model-item>
      <a-form-model-item label="内容详情" prop="content">
        <div style="max-width:800px;">
          <vue-ueditor-wrap v-model="ruleForm.content" :config="myConfig" :destroy="true"></vue-ueditor-wrap>
        </div>
      </a-form-model-item>
      <a-form-model-item label="时间" prop="startDate">
        <a-range-picker
          :placeholder="['开始时间', '结束时间']"
          format="YYYY-MM-DD HH:mm:ss"
          :value="dateValue"
          show-time
          @change="onDateChange"
          :disabledDate="disabledDate"
        />
      </a-form-model-item>
      <a-form-model-item :wrapper-col="currentFormLayout2.offsetCol">
        <a-button type="primary" @click="onSubmit" :loading="submitLoading">提交</a-button>
        <a-button @click="backEvent" style="margin-left: 20px">取消</a-button>
      </a-form-model-item>
    </a-form-model>
  </a-card>
</template>

<script>
import ruleFormMixins from '@/utils/mixins/ruleFormMixins'
import VueUeditorWrap from 'vue-ueditor-wrap'
import moment from 'moment'

export default {
  name: 'AddContent',
  mixins: [ruleFormMixins],
  components: {
    VueUeditorWrap
  },
  data() {
    return {
      ruleForm: {
        title: '',
        content: '',
        startDate: '',
        endDate: ''
      },
      dateValue: undefined,
      rules: {
        title: [{ required: true, message: '请输入标题', trigger: 'blur' }],
        content: [{ required: true, message: '请输入', trigger: 'blur' }],
        startDate: [{ required: true, message: '请选择', trigger: 'blur' }]
      },
      myConfig: {
        // 如果需要上传功能,找后端小伙伴要服务器接口地址
        // serverUrl: this.$config.baseUrl + 'ueditor/ueditorConfig',
        serverUrl: this.getFwbFileUrl(),
        // 你的UEditor资源存放的路径,相对于打包后的index.html
        UEDITOR_HOME_URL: '/UEditor/',
        // 编辑器不自动被内容撑高
        autoHeightEnabled: false,
        // 工具栏是否可以浮动
        autoFloatEnabled: false,
        // 初始容器高度
        initialFrameHeight: 340,
        // 初始容器宽度
        initialFrameWidth: '100%',
        // 关闭自动保存
        enableAutoSave: true
      },
      submitLoading: false,
      merchantId: this.$store.getters.userInfo.merchantId,
      platformId: this.getPlatformConfig().platformId,
      id: '',
      disabledDate(current) {
        return current && current < moment().startOf('day')
      }
    }
  },
  mounted() {
    this.$store.commit('SET_MENU_HEAD_CONFIG', [
      { name: 'ContentList', title: '内容列表' },
      { name: 'ContentCategory', title: '内容分类' },
      { name: 'Introduction', title: '景区介绍' },
      { name: 'ScenicAreaDynamic', title: '景区动态' }
    ])
    this.id = this.$route.query.id
    if (this.id) {
      this.getDetails()
    }
  },
  methods: {
    getDetails() {
      let url = 'scenic/spot/trend/' + this.id
      this.getHttpServices().getServerApiService().post(url)
        .then(res => {
          this.ruleForm.title = res.title
          this.ruleForm.content = res.content
          this.ruleForm.startDate = res.startDate
          this.ruleForm.endDate = res.endDate
          this.dateValue = this.getDateHelper().getDateMoments(res.startDate, res.endDate)
          this.getLogUtils().errorWithTag('dateValue', this.dateValue)
          this.getLogUtils().errorWithTag('endDate', res.endDate)
          this.getLogUtils().errorWithTag('startDate', res.startDate)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    backEvent() {
      this.$router.back(-1)
    },
    getFwbFileUrl() {
      let appConfig = this.getAppConfig()
      this.getLogUtils().logWithTag('getFwbFileUrl', appConfig)
      return appConfig.fwbUrl
    },
    onDateChange(dates, dateStrArr) {
      this.dateValue = dates
      this.ruleForm.startDate = dateStrArr[0]//出游开始日期
      this.ruleForm.endDate = dateStrArr[1]//出游结束日期
    },
    onSubmit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.submitData()
        } else {
          this.getLogUtils().logWithTag('错误', 'error submit!!')
          return false
        }
      })
    },
    // 保存接口
    submitData() {
      this.submitLoading = true
      let params = {
        ...this.ruleForm,
        merchantId: this.merchantId,
        platformId: this.platformId,
        id: this.id
      }
      this.getHttpServices().getServerApiService().post('scenic/spot/trend/save', params)
        .then(res => {
          this.submitLoading = false
          this.$message.success('保存成功')
          this.$router.back(-1)
        }).catch(reason => this.showNetWorkErrorMessage(reason))
        .finally(() => this.submitLoading = false)
    },
    getUploadFileUrl() {
      let appConfig = this.getAppConfig()
      return appConfig.baseUrl + (appConfig.isDev ? '/' : '') + 'base/upload'
    }
  }
}
</script>

<style lang="less" scoped>
.selected-image {
  width: 210px;
  height: 150px;
}
</style>